module.exports = __webpack_public_path__ + "static/media/delete.b6937761.svg";